import React, { useEffect, useState } from 'react'
import axios from 'axios'

const STREAM_URL = process.env.REACT_APP_EMBED_PAGE_API_URL
const PROXY_URL = process.env.REACT_APP_PROXY_URL
const STREAM_STATUS_INTERVAL = process.env.REACT_APP_STREAM_STATUS_INTERVAL

const EmbedApp = () => {
  const [streamUrl, setStreamUrl] = useState('')
  const [isLive, setIsLive] = useState(false)
  const [showLivePrompt, setShowLivePrompt] = useState(false)
  const [placeholderUrl, setPlaceholderUrl] = useState('')
  const [embedCode, setEmbedCode] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(STREAM_URL)
        const { stream, image, video } = response.data

        setPlaceholderUrl(image)
        setEmbedCode(video.embed_code)
        checkFirstStreamStatus(stream.live_stream_status_url)
        setStreamUrl(stream.embed_code)

        const intervalId = setInterval(() => {
          if (!isLive) {
            checkLiveStreamStatus(
              stream.live_stream_status_url,
              video.embed_code
            )
          }
        }, STREAM_STATUS_INTERVAL || 30000)

        return () => clearInterval(intervalId)
      } catch (error) {
        console.error('Error fetching event data:', error)
      }
    }

    const checkFirstStreamStatus = async (liveStreamUrl) => {
      try {
        const liveStreamStatus = await axios.get(
          `${PROXY_URL}${liveStreamUrl}`
        )

        const isLiveStreamAvailable =
          liveStreamStatus.data.current_live_viewers ||
          liveStreamStatus.data.next_live_clip

        if (isLiveStreamAvailable) {
          setIsLive(true)
        }
      } catch (error) {
        setIsLive(false)
      }
    }

    const checkLiveStreamStatus = async (liveStreamUrl, video) => {
      try {
        const liveStreamStatus = await axios.get(
          `${PROXY_URL}${liveStreamUrl}`
        )

        const isLiveStreamAvailable =
          liveStreamStatus.data.current_live_viewers ||
          liveStreamStatus.data.next_live_clip

        if (isLiveStreamAvailable && !isLive) {
          video ? setShowLivePrompt(true) : setIsLive(true)
        } else if (!isLiveStreamAvailable) {
          setShowLivePrompt(false)
          setIsLive(false)
        }
      } catch (error) {
        setIsLive(false)
      }
    }

    fetchData()
  }, [isLive])

  const handleSwitchToLive = () => {
    setIsLive(true)
    setShowLivePrompt(false)
  }

  const handleContinueWatching = () => {
    setShowLivePrompt(false)
  }

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      {/* {embedCode || (isLive && streamUrl) || streamUrl ? ( */}
      {embedCode || (isLive && streamUrl) ? (
        <iframe
          src={isLive ? streamUrl : embedCode}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{ width: '100%', height: '100%' }}

        />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%'
          }}
        >
          <img
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            src={placeholderUrl.download_url}
            width={placeholderUrl.width}
            height={placeholderUrl.height}
          />
        </div>
      )}

      {showLivePrompt && !isLive && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            color: '#fff',
            zIndex: 1000,
            borderRadius: '12px',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
            width: '80%',
            maxWidth: '400px',
            textAlign: 'center',
            transition: 'all 0.3s ease-in-out'
          }}
        >
          <p style={{ fontSize: '16px', marginBottom: '20px' }}>
            Der Live-Stream hat begonnen. Möchten Sie zum Livestream wechseln?
          </p>
          <div>
            <button
              onClick={handleSwitchToLive}
              style={{
                padding: '10px 20px',
                marginRight: '10px',
                backgroundColor: '#00aaff',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#0088cc')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#00aaff')}
            >
              Zum Live-Stream wechseln
            </button>
            <button
              onClick={handleContinueWatching}
              style={{
                padding: '10px 20px',
                backgroundColor: '#666',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#444')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#666')}
            >
              Weiterschauen
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default EmbedApp
